import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const skip = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/me"];
    if (error.response?.status === 401 && !original._retry && !skip.some((p) => url.includes(p))) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export const DEVICE_TYPE_LABELS = {
  apple_watch: "Apple Watch",
  iphone_relay: "iPhone Relay",
  wearable: "Wearable",
  mia_device: "MIA Device",
  other: "Other",
};

export function timeAgo(iso) {
  if (!iso) return "Never";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  if (diff < 60_000) return "Just now";
  const mins = Math.floor(diff / 60_000);
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString();
}

export async function downloadExport() {
  const res = await api.get("/v1/privacy/export", { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/json" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `mia-export-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
